module.exports = __webpack_public_path__ + "img/dengji5.ad529314.png";